import AssessmentServer from '@/api/assessment'

export default {

    namespaced: true,

    state: {

        assessmentVersionTable: [],

        assessmentVersionDetail: {},

        assessmentVersionList: [],
    },

    getters: {

        assessmentVersionTable(state) {
            return state.assessmentVersionTable;
        },

        assessmentVersionDetail(state) {
            return state.assessmentVersionDetail;
        },

        assessmentVersionList(state) {
            return state.assessmentVersionList;
        },

    },

    mutations: {

        setAssessmentVersionTable(state, payload) {
            state.assessmentVersionTable = payload;
        },

        setAssessmentVersionDetail(state, payload) {
            state.assessmentVersionDetail = payload;
        },

        setAssessmentVersionList(state, payload) {
            state.assessmentVersionList = payload;
        }
    },

    actions: {

        getAssessmentVersionTable({commit}, payload) {
            return new Promise((resolve, reject) => {
                AssessmentServer.assessmentVersion.page(payload).then((responseBody) => {
                    commit("setAssessmentVersionTable", {
                        tableData: responseBody.data.data.pageData,
                        total: responseBody.data.data.total,
                    });
                });
            }).catch(error => {
                console.log('获取ASSESSMENVERSION信息失败');
                reject(error);
            });
        },

        getAssessmentVersionDetail({commit}, payload) {
            return new Promise((resolve, reject) => {
                AssessmentServer.assessmentVersion.get(payload).then((responseBody) => {
                    commit("setAssessmentVersionDetail", responseBody.data.data);
                });
            }).catch(error => {
                console.log('获取ASSESSMENVERSION详情失败');
                reject(error);
            });
        },

        getAssessmentVersionList({commit}, payload) {
            return new Promise((resolve, reject) => {
                AssessmentServer.assessmentVersion.list(payload).then((responseBody) => {
                    commit("setAssessmentVersionList", responseBody.data.data);
                });
            }).catch(error => {
                console.log('获取ASSESSMENVERSION列表失败');
                reject(error);
            });
        },
    },
    

}